import React from 'react';
import PropTypes from 'prop-types';

import { PropTypesRepo } from '../functions/_propTypes';
import Div from './Div';

const Label = ({ ...rest }) => <Div {...rest}>{rest.children}</Div>;

/* eslint-disable react/require-default-props */

Label.propTypes = {
  tag: PropTypes.string,
  d: PropTypesRepo.d,
  pos: PropTypesRepo.pos,
  top: PropTypesRepo.top,
  bottom: PropTypesRepo.bottom,
  left: PropTypesRepo.left,
  right: PropTypesRepo.right,
  justify: PropTypesRepo.justify,
  align: PropTypesRepo.align,
  flexDir: PropTypesRepo.flexDir,
  flexGrow: PropTypesRepo.flexGrow,
  flexWrap: PropTypesRepo.flexWrap,
  order: PropTypesRepo.order,
  m: PropTypesRepo.m,
  p: PropTypesRepo.p,
  rounded: PropTypesRepo.rounder,
  border: PropTypesRepo.border,
  borderColor: PropTypesRepo.borderColor,
  h: PropTypesRepo.h,
  maxH: PropTypesRepo.maxH,
  minH: PropTypesRepo.minH,
  w: PropTypesRepo.w,
  maxW: PropTypesRepo.maxW,
  minW: PropTypesRepo.minW,
  cursor: PropTypesRepo.cursor,
  bg: PropTypesRepo.bg,
  bgImg: PropTypesRepo.bgImg,
  bgSize: PropTypesRepo.bgSize,
  bgRepeat: PropTypesRepo.bgRepeat,
  bgPos: PropTypesRepo.bgPos,
  textSize: PropTypesRepo.textSize,
  textColor: PropTypesRepo.textColor,
  textWeight: PropTypesRepo.textWeight,
  textAlign: PropTypesRepo.textAlign,
  textTransform: PropTypesRepo.textTransform,
  fontFamily: PropTypesRepo.fontFamily,
  transition: PropTypesRepo.transition,
  shadow: PropTypesRepo.shadow,
  transformOrigin: PropTypesRepo.transformOrigin,
  zIndex: PropTypesRepo.zIndex,
  overflow: PropTypesRepo.overflow,
  opacity: PropTypesRepo.opacity,
  hoverBg: PropTypesRepo.hoverBg,
  hoverTextColor: PropTypesRepo.hoverTextColor,
  hoverBorderColor: PropTypesRepo.hoverBorderColor,
  hoverShadow: PropTypesRepo.hoverShadow,
};

/* eslint-enable react/require-default-props */

Label.defaultProps = {
  tag: 'label',
  flexWrap: 'wrap',
  textSize: 'body',
  d: 'flex',
  align: 'flex-start',
  cursor: 'pointer',
};

export default Label;
